import React from "react";
import { useSpecialFunctions } from "../../functions";
import Rights from "../../constants/Rights";

const PastPostsTable = ({
  pastPosts,
  voidTickets,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  callFrom,
  setSelectedTicketsVoidScoreContainer,
  selectedTicketsVoidScoreContainer,
}) => {
  const { getTimeInfo, getDateInfo } = useSpecialFunctions();
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];
  const hasSelectAllPermissions = () =>
    userRightsList.some((right) =>
      [Rights.FRM_VOID_TICKET, Rights.FRM_SCORE_TICKETS].includes(
        right.FormName,
      ),
    );

  const ticketsChangeHandler = (ticketID) => {
    if (!hasSelectAllPermissions()) {
      return;
    }
    if (selectedTicketsVoidScoreContainer.includes(ticketID)) {
      // If the id is already in the list, it deletes it.
      setSelectedTicketsVoidScoreContainer(
        selectedTicketsVoidScoreContainer.filter((item) => item !== ticketID),
      );
    } else {
      // If the id is not in the list, it adds it.
      setSelectedTicketsVoidScoreContainer([
        ...selectedTicketsVoidScoreContainer,
        ticketID,
      ]);
    }
  };

  const handleSelectAll = () => {
    const allTicketIDs = pastPosts.map((item) => item.TicketID);

    if (selectAllTickets) {
      setSelectedTicketsVoidScoreContainer([]);
    } else {
      setSelectedTicketsVoidScoreContainer(allTicketIDs);
    }

    setSelectAllTickets(!selectAllTickets);
  };

  let headers,
    tableContent = [];

  //Charge Open Bets Table
  if (pastPosts) {
    tableContent = pastPosts.map((data, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={"tr" + data.TicketID}
            style={{
              cursor: hasSelectAllPermissions() ? "pointer" : "inherit",
              verticalAlign: "middle",
            }}
            onClick={() => ticketsChangeHandler(data.TicketID)}
            className={
              selectedTicketsVoidScoreContainer.includes(data.TicketID)
                ? "shadedRow"
                : ""
            }
          >
            <td className="d-none">{data.IdWager}</td>

            <td
              key={"td" + data.TicketNumber}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {getDateInfo(data.PlacedDateTime)} <br />
              {getTimeInfo(data.PlacedDateTime)}
            </td>
            <td
              key={"userPl" + data.IdWager}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                width: "200px",
              }}
            >
              {data.AccountUserName}
            </td>

            <td
              key={"desc" + data.IdWager}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "450px",
              }}
            >
              {data.TicketDesc} {data.Selections}
            </td>

            <td
              key={"td"}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {data.TotalStake} / {data.WinPaid}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th hidden>TicketID</th>
      <th style={{ width: "150px" }}>Placed</th>
      <th>Account</th>
      <th>Description</th>
      <th>Risk / Win</th>
    </tr>
  );

  let riskAmountWagers = [],
    totalAtRisk;

  pastPosts.forEach((data, i) => {
    riskAmountWagers.push(parseInt(data.TotalStake));
  });

  totalAtRisk = riskAmountWagers.reduce((a, b) => a + b, 0);

  return (
    <>
      <div
        className="col-sm-12 mt-2 mb-1 lead text-center"
        style={{ height: "35px", backgroundColor: "#F2F2F2" }}
      >
        <span
          style={{
            color: "#808080",
            fontWeight: "bold",
            lineHeight: "35px",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
          }}
        >
          {callFrom === "PastPost" ? "Past Post Tickets" : "Open Tickets"}{" "}
        </span>
      </div>

      <div className="row">
        <div className="col-sm-4">
          <div className="form-check mt-4">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
              checked={selectAllTickets}
              onChange={handleSelectAll}
              disabled={pastPosts?.length === 0 || !hasSelectAllPermissions()}
            />
            <label
              className="form-check-label"
              htmlFor="exampleCheck1"
              style={{ color: "#8c8c8c", fontSize: "16px" }}
            >
              Select All Tickets
            </label>
          </div>
        </div>
        <div className="col-sm-8 mt-1 mb-0" style={{ textAlign: "right" }}>
          {userRightsList.find(
            (right) => right.FormName === Rights.FRM_VOID_TICKET,
          ) && (
            <button
              type="button"
              className="btn btn-success mb-0"
              onClick={() =>
                voidTickets(
                  callFrom === "PastPost"
                    ? "PPTScoreUnscore"
                    : "OTScoreUnscore",
                  selectedTicketsVoidScoreContainer,
                )
              }
            >
              Void Selected Tickets
            </button>
          )}
          {userRightsList.find(
            (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
          ) && (
            <button
              type="button"
              className="btn btn-success mb-0"
              onClick={() =>
                scoreTickets(
                  callFrom === "PastPost"
                    ? "PPTScoreUnscore"
                    : "OTScoreUnscore",
                  selectedTicketsVoidScoreContainer,
                )
              }
            >
              Score Selected Tickets
            </button>
          )}
        </div>
      </div>

      <div
        style={{ overflow: "auto", marginTop: "10px" }}
        className="pastPostTable mb-1"
      >
        <table className="table table-hover table-sm">
          <thead
            style={{ position: "sticky", top: "0", background: "#F2F2F2" }}
          >
            {headers}
          </thead>
          <tbody className="table-sm">{tableContent}</tbody>
        </table>
      </div>
      <div
        className="col-sm-12 mt-2"
        style={{
          height: "25px",
          borderTop: "1px outset #cccccc",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            color: "#8c8c8c",
            fontWeight: "bold",
            lineHeight: "23px",
          }}
        >
          {pastPosts.length} Wager(s)
        </span>
        <span
          style={{
            color: "#8c8c8c",
            lineHeight: "23px",
            fontWeight: "bold",
          }}
        >
          At Risk: $ {totalAtRisk}
        </span>
      </div>
    </>
  );
};

export default PastPostsTable;
